import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M533.333 247.677V141.011H1920v106.666H533.333zm0 853.334V994.237H1920v106.774H533.333zm0-426.774V567.571H1920v106.666H533.333zM0 141h106.667v1280H457.92l-175.573-175.68 75.306-75.413 304.427 304.32-304.427 304.426-75.306-75.413 175.573-175.573H0V141zm853.333 1386.57v-106.666h213.334v106.667H853.333zm426.667 0v-106.666h213.333v106.667H1280zm426.667 0v-106.666H1920v106.667h-213.333z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveDownBottomLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveDownBottomLine, _Component);

  var _super = _createSuper(IconMoveDownBottomLine);

  function IconMoveDownBottomLine() {
    _classCallCheck(this, IconMoveDownBottomLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveDownBottomLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveDownBottom",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveDownBottomLine.displayName = "IconMoveDownBottomLine";
  return IconMoveDownBottomLine;
}(Component);

IconMoveDownBottomLine.glyphName = 'move-down-bottom';
IconMoveDownBottomLine.variant = 'Line';
IconMoveDownBottomLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveDownBottomLine;
export { IconMoveDownBottomLine };